import { Language } from '../../../enums/const-enums';

export interface RassSignTranslations {
  errors: {
    timeout: AppModel.TimeoutTranslation;
    continue: string;
  };
}

const nlTranslations: RassSignTranslations = {
  errors: {
    timeout: {
      text: 'Fout bij het bereiken van de server, probeer opnieuw!',
      type: 'warning',
    },
    continue: 'Doorgaan',
  },
};

const enTranslations: RassSignTranslations = {
  errors: {
    timeout: {
      text: 'Error while reaching the server, please try again!',
      type: 'warning',
    },
    continue: 'Continue',
  },
};

export const rassSignTranslations: Record<Language, RassSignTranslations> = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: enTranslations,
  [Language.PT]: enTranslations,
};
